
export enum UserRole {
    Admin = 'role/administrator',
    Copywriter = 'role/copywriter',
    BrokerAgent = 'role/broker-agent',
    BrokerAgentAssistent = 'role/broker-agent-assistant',
    BrokerAgentAdmin = 'role/broker-agent-admin',
    Seller = 'role/seller',
    Stylist = 'role/stylist',
    Support = 'role/support',
    Economist = 'role/economist',
    Management = 'role/management',
    Photographer = 'role/photographer',
    PhotoEditor = 'role/image-editor',
    PlanEditor = 'role/plan-editor',
    ImageEditorAdmin = 'role/image-editor-admin',
    PlanEditorAdmin = 'role/plan-editor-admin',
    StylingAdmin = 'role/styling-admin'
}

export enum Role {
    Admin = 'Admin',
    Copywriter = 'Copywriter',
    Broker = 'Broker',
    Photographer = 'Photographer',
    Stylist = 'Stylist',
    PhotoEditor = 'Photo editor',
    PlanEditor = 'Plan editor',
    NoUserRole = ''
}

export function getUserRole(userRole) {
    if (
        userRole === UserRole.Admin ||
        userRole === UserRole.Economist ||
        userRole === UserRole.Support ||
        userRole === UserRole.Management
    ) {
        return Role.Admin;
    }
    if (userRole === UserRole.Copywriter) {
        return Role.Copywriter;
    }
    if (
        userRole === UserRole.BrokerAgent ||
        userRole === UserRole.BrokerAgentAssistent ||
        userRole === UserRole.BrokerAgentAdmin
    ) {
        return Role.Broker;
    }
    if (userRole === UserRole.Photographer) {
        return Role.Photographer;
    }
    if (userRole === UserRole.Stylist || userRole === UserRole.StylingAdmin) {
        return Role.Stylist;
    }
    if (userRole === UserRole.PhotoEditor || userRole === UserRole.ImageEditorAdmin) {
        return Role.PhotoEditor;
    }
    if (userRole === UserRole.PlanEditor || userRole === UserRole.PlanEditorAdmin) {
        return Role.PlanEditor;
    }
    return Role.NoUserRole;
}
